import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import Layout from 'components/Layout';
import Wizard from 'components/UI/Wizard';
import { useParams } from 'react-router-dom';
import { uiActions } from 'state/modules/UI';
import { useHistory } from 'react-router-dom';
import { vehicleActions } from 'state/modules/vehicles';
import { Container, Typography, Box } from '@mui/material';
import { VehiclesTypesWizardDetails } from 'components/VehiclesTypes';

const VehiclesTypesOnboarding = () => {
  const { id } = useParams();
  const history = useHistory();
  const [showSaveAndExitModal, setShowSaveAndExitModal] = useState(false);
  const successMessage = `Vehicle type ${id ? 'updated' : 'created'} successfully`;

  const { fetchedVehicleTypeSuccess, loadingVehicleType, vehicleType, errors } = useSelector(
    (state) => state.vehicles
  );

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const setTitle = () => {
    if (id) {
      return `Vehicle type ID #${id}`;
    }
    return 'Create vehicle type';
  };

  useEffect(() => {
    if (id) {
      dispatch(vehicleActions.fetchVehicleTypeById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (fetchedVehicleTypeSuccess) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: successMessage,
        })
      );
      if (id) {
        return history.push(buildUrl(`/vehicle-types/${id}`));
      }
      history.push(buildUrl('/vehicle-types'));
    }
  }, [id, dispatch, history, successMessage, fetchedVehicleTypeSuccess]);

  const saveForm = () => {
    if (formRef?.current) {
      return formRef.current.submitForm();
    }
  };

  const handleEndOnboarding = () => {
    dispatch(vehicleActions.resetVehicleTypeOnboarding());
    history.push(buildUrl('/vehicle-types'));
  };

  const handleExit = () => {};

  const handleShowOnSaveAndExitModal = () => {
    setShowSaveAndExitModal((prevState) => !prevState);
  };

  const vehicleTypeWizard = () => {
    return (
      <Box>
        <Wizard
          position={0}
          mode="create"
          exit={true}
          onNext={saveForm}
          title={setTitle()}
          handleExit={handleExit}
          loading={loadingVehicleType}
          successMessage={successMessage}
          saveButtonText={i18n.t('common.save')}
          handleEndOnboarding={handleEndOnboarding}
          showSaveAndExitModal={showSaveAndExitModal}
          handleShowOnSaveAndExitModal={handleShowOnSaveAndExitModal}
        >
          <VehiclesTypesWizardDetails vehicleType={vehicleType} formRef={formRef} errors={errors} />
        </Wizard>
      </Box>
    );
  };

  return (
    <Layout title="Dashboard">
      <Container maxwidth="lg">
        <Grid
          container
          rowSpacing={1}
          direction="row"
          alignItems="center"
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid size={12}>
            <Typography variant="h6" gutterBottom mb="48px">
              <Box fontWeight="bold" fontSize={24} mb={1}>
                {setTitle()}
              </Box>
            </Typography>
          </Grid>
          <Grid size={12}>{vehicleTypeWizard()}</Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default VehiclesTypesOnboarding;
